import { registerRendererGroup, registerToolRendererGroup, ShapeFunctions } from "../../util/shapeCategorySingleton";
import { calculateLineSnapPoints, createLine, createLineRubber, globalLine, lineBoundingboxCalculation, lineIntersectWithRect, splitByLine, transformLineToInternalShape } from "./Line";
import { createLineBase } from "./LineBase";
import createDefaultPropertyPalette from "./LineDefaultProperyPalette";
import { createLineFloatingPalette } from "./LineFloatingPalette";
import createPropertyPalette from "./LineProperyPalette";

const lineFunctions: ShapeFunctions = {
  shapeRendererGroup: {
    shapeRender: createLine,
    rubberlineRender: createLineRubber,
    baseShapeRenderer: createLineBase,
  },
  shapeTransformerGroup: {
    snapPointCalculator: calculateLineSnapPoints,
    rectangleIntersectCheck: (s: GeometricShape, r: RectSel) => {
      return lineIntersectWithRect(s, r);
    },
    globalShapeTransformer: globalLine,
    transformToInternalShape: transformLineToInternalShape,
    calculateWidthHeight: lineBoundingboxCalculation,
    shapeSplit: splitByLine,
  },
  UIElementRender: {
    propertyPaletteRenderer: createPropertyPalette,
    defaultPropertyPaletteRenderer: createDefaultPropertyPalette,
    floatingPalette: createLineFloatingPalette,
  },
}

registerRendererGroup("line", lineFunctions);
registerRendererGroup("polyline", lineFunctions);
registerToolRendererGroup("line", { toolRender: createLineRubber });